import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[appPenaltyEdit]' })
export class PenaltyEditDirective implements AfterViewInit {
  private el = inject(ElementRef);

  @Input() row: any;
  @Input() previousValue: any;
  @Input() stopEdit!: (row: any, col: string) => void;
  @Input() cancelEdit!: (row: any, col: string) => void;

  ngAfterViewInit() {
    // Focus automatique dans l’input des yards
    const input: HTMLInputElement | null = this.el.nativeElement.querySelector('input');
    if (input) {
      setTimeout(() => input.focus());
    }
  }

  // ESC → rollback
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event) {
    event.preventDefault();
    if (this.cancelEdit) {
      this.row.penTeam = this.previousValue?.penTeam;
      this.row.penYards = this.previousValue?.penYards;
      this.cancelEdit(this.row, 'penalty');
    }
  }

  // clic extérieur → save
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.stopEdit(this.row, 'penalty');
    }
  }
}
